import BaseView from '../../../js/base-view';

const SELECTOR_TOTAL_AMOUNT     = '.shop-navbar .woocommerce-Price-amount';
const SELECTOR_ITEMS_COUNT      = '.shop-navbar__customer-link.my-cart-item-count span';

export default class ShopNavbar extends BaseView {
	init() {
		this.refs = {
			amount: this.el.querySelector(SELECTOR_TOTAL_AMOUNT),
			itemsCount: this.el.querySelector(SELECTOR_ITEMS_COUNT),
		};

		this.bindEvents();
	}

	bindEvents() {
		this.updateCart = this.updateCart.bind(this);
		this.on('added-to-cart', this.updateCart, true);
		this.on('update-checkout', this.updateCart, true);
		this.on('removed-from-cart', this.updateCart, true);
		this.on('cart-emptied', this.updateCart, true);
		this.on('updated-cart', this.updateCart, true);
		this.on('applied-coupon', this.updateCart, true);
		this.on('removed-coupon', this.updateCart, true);
	}

	/*
	 * Fetch data and update the cart
	 */
	updateCart() {
		fetch(`${window.supt.restAPI.root}/supt/v1/cart`)
			.then(response => response.json())
			.then((response) => {
				this.refs.amount.innerHTML = response.total_price;
				this.refs.itemsCount.textContent = response.item_count;
			});
	}
}
